import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { difference, filter, remove } from 'lodash';

import { MlResetKpiDataService } from '@nrwl/threshold-settings';

import { IValueChangedEvent, IWizardContentComponent } from '../../../../wizard.content';
import { PaginatorComponent } from '@nrwl/common-lib';

export interface IChooseOptions {
  id: number;
  name: string;
  description: string;
  kpiData: [];
  subtitle?: string;
  expandable?: any; //eslint-disable-line @typescript-eslint/no-explicit-any
}

@Component({
  selector: 'nrwl-ml-select-kpi',
  templateUrl: './ml-select-kpi.component.html',
  styleUrls: ['./ml-select-kpi.component.scss']
})
export class MlSelectKpiComponent implements IWizardContentComponent, OnInit, AfterViewInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('paginator', { static: true }) paginatorComponent: PaginatorComponent;

  kpiData: MatTableDataSource<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  displayedColumns: string[] = ['name'];
  selectedElement: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  chosenKpiOption: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  selectedCustomKpi: Array<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  hidePaginator = true;
  defaultParams: IChooseOptions;
  numberOfKPI: number;
  chooseOptions: IChooseOptions[] = [
    {
      id: 0,
      name: 'All',
      description: 'All KPIs',
      kpiData: []
    },
    {
      id: 1,
      name: 'Custom',
      description: 'Custom KPI configuration',
      subtitle: 'Select individual KPIs',
      kpiData: [],
      expandable: {
        value: false
      }
    }
  ];

  get paginatorStatus(): boolean {
    return this.hidePaginator;
  }

  constructor(private mlResetKpiDataService: MlResetKpiDataService) {}

  ngOnInit(): void {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.selectedCustomKpi = new Array<any>();
    this.defaultParams = this.step.parent.defaultParamsById;
    const allKpis = this.mlResetKpiDataService.getAllKpi();
    this.kpiData = new MatTableDataSource(allKpis);
    this.numberOfKPI = allKpis.length;
    if (this.defaultParams && this.defaultParams.id >= 0) {
      const id = this.defaultParams.id;
      this.onOptionClick(this.chooseOptions[id]);
      this.defaultParams.kpiData.forEach(data => {
        this.onRowClick(data);
      });
    }
  }

  ngAfterViewInit(): void {
    this.kpiData.paginator = this.paginatorComponent.paginator;
  }

  nextPage(event: PageEvent): void {
    this.kpiData.paginator.pageIndex = event.pageIndex;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onOptionClick(chosenOption: any): void {
    this.chosenKpiOption = this.chooseOptions[chosenOption.id];
    this.prepareForChosenKpiOption(chosenOption);
    this.emitKpiOptionChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onRowClick(data: any): void {
    this.selectedElement = data;

    if (filter(this.selectedCustomKpi, data).length) {
      remove(this.selectedCustomKpi, kpi => kpi.key === data.key);
    } else {
      this.selectedCustomKpi.push(data);
    }

    this.chosenKpiOption.kpiData = this.selectedCustomKpi;
    this.emitKpiOptionChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  selectCustomKpiOnClick(clickedKpiElement: any): any {
    if (!this.selectedElement) {
      return false;
    }

    return filter(this.selectedCustomKpi, clickedKpiElement).length;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  private prepareForChosenKpiOption(chosenOption: any): void {
    if (chosenOption.expandable) {
      chosenOption.expandable.value = true;
      this.selectedCustomKpi = [];
      this.chosenKpiOption.kpiData = [];
      this.hidePaginator = false;
    } else {
      this.chosenKpiOption.kpiData = this.mlResetKpiDataService.getAllKpi();
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      const differentOpt: any = difference(this.chooseOptions, [chosenOption])[0];
      if (differentOpt.expandable) {
        differentOpt.expandable.value = false;
        this.hidePaginator = true;
      }
    }
  }

  private emitKpiOptionChanges(): void {
    const isValid = this.chosenKpiOption.kpiData.length > 0;
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'kpiObjectInput',
      key: 'kpiObject',
      newValue: this.chosenKpiOption,
      isValid: isValid
    });
  }
}
